var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DropMoleculeItemList d-flex"},_vm._l((_vm.items),function(quantity,id){return _c('ItemSmart',{key:`item-${id}`,attrs:{"id":+id,"quantity":quantity}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }